<template>
  <div
    id="js-navbar-topgap"
    class="pt-4 hidden lg:block"
  />
  <nav
    id="js-navbar"
    class="navbar navbar--basket hidden lg:block"
    :class="{ 'is-fixed': isFixed }"
  >
    <div class="overflow-hidden">
      <div
        class="hidden lg:block absolute w-100 h-100"
        :class="backgroundColor"
        :style="{ opacity: isFixed ? 1 : 0 }"
      />
      <div class="container">
        <div class="form-row flex-nowrap items-center py-1 lg:py-0 lg:mx-0 xxl:px-5">
          <Logo />

          <!-- text -->
          <div class="col lg:pr-4">
            <p class="h1 m-0 text-white text-center text-nowrap uppercase">
              {{ t('order') }}
            </p>
          </div>

          <!-- rightside of navbar (menu, login, favourite, basket, language,..) -->
          <div class="navbar__rightside col-auto ml-auto px-0 lg:pl-5 hidden lg:flex self-stretch">
            <div class="flex flex-col justify-center flex-grow-1 relative">
              <div class="form-row items-center">
                <Toolbar type="short" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import Logo from '@/components/menus/navbar/TheNavbarLogo.vue'
import Toolbar from '@/components/menus/navbar/TheNavbarToolbar.vue'
import { useNavbarStore } from '@/stores/NavbarStore'

const { t } = useI18n()
const navbarStore = useNavbarStore()
const topGap = ref({})
const isFixed = ref(false)

const { backgroundColor } = storeToRefs(navbarStore)

const observe = () => {
  topGap.value = document.querySelector('#js-navbar-topgap')
  const observer = new IntersectionObserver(toggleFixedState)
  observer.observe(topGap.value)
}

const toggleFixedState = (entries) => {
  for (const entry of entries) {
    isFixed.value = !entry.isIntersecting
  }
}

onMounted(() => {
   observe()
})
</script>

<i18n>
  {
    "cs": {
    "order": "Rekapitulace objednávky"
},
    "sk": {
    "order": "Rekapitulácia objednávky"
},
    "pl": {
    "order": "Podsumowanie zamówienia"
},
    "hu": {
    "order": "A megrendelés összefoglalása"
},
    "de": {
    "order": "Zusammenfassung der Bestellung"
},
    "at": {
    "order": "Zusammenfassung der Bestellung"
},
    "ro": {
    "order": "Sumar al comenzii"
},
    "fr": {
    "order": "Récapitulatif de la commande"
},
    "it": {
    "order": "Riepilogo dell'ordine"
}
  }
</i18n>
